import { StyledHtml } from '@postenbring/hedwig-react';
import './text.scss';

const CLASSES = {
    small: 'kp-text-small',
    large: 'kp-text-large'
}

export const Text = ({text, size }) => {
    const className = `kp-text hds-mb-24 ${CLASSES[size] || ""}`
    return (
        <StyledHtml dangerouslySetInnerHTML={{__html: text}} className={className}/>
    )
}

